import IMBgImage from '../../components/common/IMBgImage';
import IMTitle from '../../components/typography/IMText';
import IMText from '../../components/typography/IMTitle';
import IMButton from '../../components/common/buttons/IMButton';
import IMSlider from '../../components/common/IMSlider';
import IMQuestionsProgressBar from '../../components/common/IMQuestionsProgressBar';
import IMPage from '../../components/common/layout/IMPage';
import { Box, Snackbar } from '@mui/material';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../store/store';
import { useNavigate } from 'react-router-dom';
import { activateNextCard, fetchNextCard, selectTotalSectionsCount } from '../../store/idealCountrySlice';

const Questions = () => {
	const navigate = useNavigate();
	const dispatch = useDispatch<AppDispatch>();

	const card = useSelector((state: RootState) => state.idealCountry.currentCard);
	const curCardIndex = useSelector((state: RootState) => state.idealCountry.currentCardIndex);
	const sessionToken = useSelector((state: RootState) => state.idealCountry.sessionToken);
	const totalSectionsCount = useSelector(selectTotalSectionsCount);

	const [snackbarOpen, setSnackbarOpen] = useState(false);
	const [voteValue, setVoteValue] = useState(0);

	useEffect(() => {
		if (!card) {
			navigate('/start');
		}
	}, []);

	const onClickNext = async () => {
		if (!card) return;
		const value = Math.floor((voteValue / 100) * 11);
		const res = await dispatch(
			fetchNextCard({
				cardId: card.id,
				value,
				sessionId: sessionToken,
			})
		);
		if (fetchNextCard.rejected.match(res)) {
			setSnackbarOpen(true);
			console.error('Failed to fetch next card', res);
			return;
		}

		const nextCard = (res.payload as any).card;
		const nextCardIndex = nextCard ? curCardIndex + 1 : -1;

		// if (card.id === 4) { // finish
		// 	navigate('/result');
		// 	return;
		// }

		if (!nextCard) { // finish
			navigate('/result');
			return;
		}
		if (nextCardIndex % 5 === 0) {
			navigate('/subResult');
			return;
		}

		dispatch(activateNextCard());
		setVoteValue(0);
	};

	const handleSnackbarClose = (
		event?: React.SyntheticEvent | Event,
		reason?: string
	) => {
		if (reason === 'clickaway') {
			return;
		}
		setSnackbarOpen(false);
	};

	return (
		card && (
			<IMPage>
				<IMQuestionsProgressBar questionIndex={curCardIndex + 1} totalStages={totalSectionsCount}></IMQuestionsProgressBar>
				<Box
					sx={{
						position: 'relative',
						height: '100%',
					}}
				>
					<Box
						sx={{
							position: 'absolute',
							height: '100%',
							width: '100%',
							zIndex: 0,
						}}
					>
						<IMBgImage src={card.image_url} alt="" />
					</Box>
					<Box
						sx={{
							position: 'absolute',
							width: '100%',
							bottom: 0,
							zIndex: 1,
						}}
					>
						<Box
							sx={{
								marginBottom: '18px',
								marginX: '16px',
							}}
						>
							<IMTitle
								weight="700"
								size="22px"
								color="#FFFFFF"
								textAlign="center"
							>
								{card.description}
							</IMTitle>
							<Box
								sx={{
									backgroundColor: '#FFFFFF',
									borderRadius: '8px',
									height: '91px',
									marginTop: '16px',
									display: 'flex',
									flexDirection: 'column',
								}}
							>
								<IMSlider
									value={voteValue}
									onChange={(value) => setVoteValue(value)}
									sx={{
										margin: '10px 12px 12px 12px',
									}}
								></IMSlider>
								<Box
									sx={{
										display: 'flex',
										height: '100%',
										justifyContent: 'space-between',
										margin: '0 12px',
									}}
								>
									<IMText
										weight="400"
										size="12px"
										color="#909090"
										textAlign="left"
										props={{ width: '100%' }}
									>
										Не важно
									</IMText>
									<IMText
										weight="400"
										size="12px"
										color="#909090"
										textAlign="right"
										props={{ width: '100%' }}
									>
										Очень важно
									</IMText>
								</Box>
							</Box>
						</Box>
					</Box>
				</Box>
				<Box
					sx={{
						paddingX: '16px',
						display: 'flex',
						height: '48px',
						marginBottom: '30px',
					}}
				>
					<IMButton sx={{ width: '100%' }} onClick={onClickNext}>
						Далее
					</IMButton>
				</Box>
				<Snackbar
					open={snackbarOpen}
					autoHideDuration={2000}
					onClose={handleSnackbarClose}
					message="Ошибка при отправке результата"
					anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
				/>
			</IMPage>
		)
	);
};

export default Questions;
